<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {getLoggedUser} from '@/services/AuthService';
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {showSuccessMessage} from "@/helper";
import router from "@/router";
import {useDataTable} from "@/utils/datatableHelper";
import ContractTypeService from "@/services/ContractTypeService";
import CreateUpdateContractTypeModal from "@/components/modals/CreateUpdateContractTypeModal.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const datatableRef = ref(null);
const datatable = useDataTable(fetchContractTypes, 'name', 10, true, {}, 'CONTRACT-TYPES-INDEX', datatableRef);

const loggedUser = ref({});

const isEditable = ref(false);

const columns = ref([
  {
    label: t('contractTypesIndex.name'),
    field: 'name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('contractTypesIndex.description'),
    field: 'description',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
    {
    label: t('contractTypesIndex.active'),
    field: 'is_active',
    filterOptions: {
      enabled: false
    },
    formatFn: (value) => {
      return value ? t('contractTypesIndex.yes') : t('contractTypesIndex.no');
    }
  },
  {
    label: 'Aktivní pro přidávání nových produktů',
    field: 'is_active_new_products',
    filterOptions: {
      enabled: false
    },
    formatFn: (value) => {
      return value ? 'Ano' : 'Ne';
    }
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(() => {
  Promise.all([getLoggedUser()])
      .then(([userResponse]) => {
        loggedUser.value = userResponse;
        if (loggedUser.value.role === 'ADMIN' || loggedUser.value.role === 'SUPERADMIN' || loggedUser.value.role === 'BACK_OFFICE') {
          isEditable.value = true;
        }
      });
});

function fetchContractTypes(body) {
  datatable.isLoading.value = true;
  ContractTypeService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    datatable.rows.value = response.data;
    datatable.isLoading.value = false;
  });
}

function createContractType() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateContractTypeModal, {});
  reveal();
  onConfirm((data) => {
    ContractTypeService.saveContractType(data).then(response => {
      showSuccessMessage(response.message);
      fetchContractTypes(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> Zpět</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('contractTypesIndex.contract_type') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <Button :label="t('contractTypesIndex.add_contract_type')" icon="mdi-text-box-plus" @click="createContractType()"></Button>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <vue-good-table
          ref="datatableRef"
          :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
          :columns="columns"
          :rows="datatable.rows.value"
          mode="remote"
          @page-change="datatable.onPageChange"
          @sort-change="datatable.onSortChange"
          @column-filter="datatable.onColumnFilter"
          @per-page-change="datatable.onPerPageChange"
          :totalRows="datatable.totalRecords.value"
          :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('contractTypesIndex.entriesPerPage'),
                  nextLabel: t('contractTypesIndex.next'),
                  prevLabel: t('contractTypesIndex.previous'),
                  ofLabel: 'z',
                }">
        <template #table-row="props">
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
                                    <router-link :to="{ name: 'ContractTypeDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                    </span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!datatable.isLoading.value">
          <div class="text-center">
            {{ t('contractTypesIndex.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="datatable.isLoading.value">
          <div class="text-center">
            {{ t('contractTypesIndex.loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
